<template lang="html">

  <div data="idiomas" class="cv-part" >

    <h2 @click="openedit" class="title" :edit="showedit" :empty="!!!info">Idiomas</h2>
    <template v-if="!!info">
      <div class="edit-options" :edit="showedit" v-for="idioma in info" v-if="info.length != 0">
        <button class="editar" @click="setEditIdioma(idioma)"">Editar</button>
        <button class=" eliminar" @click="eraseIdioma(idioma.id)">✕</button>
        <p :edit="showedit">
          <strong v-if="idioma.idioma != 7">{{dominios.idioma[idioma.idioma]}}</strong>
          <strong v-else>{{idioma.otro}}</strong><template v-if="!!idioma.nivel">: {{dominios.nivelidioma[idioma.nivel]}}</template>
          <template> - {{(idioma.certificacion) ? 'Con' : 'Sin'}} certificación</template>
        </p>
      </div>
    </template>
    <template v-if="!!!info || info.length == 0">
      <p>Aún no tienes idiomas añadidos, pulsa en añadir idioma para añadirlo</p>
    </template>

    <button class="btn skull" @click="openadd">+ Añadir idioma</button>

    <div class="cover-popup row-center" v-if="showadd">
      <div class="popup">

        <a class="close" @click="showadd = false">✕</a>
        <h2 class="title-pop">Añadir idioma</h2>

        <select v-model="newidioma.idioma" v-validate="'required'" name="idioma" :error="errors.has('idioma')">
          <option value="">Selecciona un idioma</option>
          <option v-for="(idioma,key) in dominios.idioma" :value="key">{{idioma}}</option>
        </select>
        <span class="error animated shake" v-if="errors.has('idioma')">{{ errors.first('idioma') }}</span>

        <input type="text" name="otro_idioma" v-validate="'required'" v-model="newidioma.otro"
          placeholder="Introduce el nombre del idioma" :error="errors.has('otro_idioma')"
          v-if="newidioma.idioma == '7'">
        <span class="error animated shake" v-if="errors.has('otro_idioma')">{{ errors.first('otro_idioma') }}</span>

        <select v-model="newidioma.nivel" v-validate="'required'" name="nivel" :error="errors.has('nivel')">
          <option value="">Selecciona tu nivel</option>
          <option v-for="(nivel,key) in dominios.nivelidioma" :value="key">{{nivel}}</option>
        </select>
        <span class="error animated shake" v-if="errors.has('nivel')">{{ errors.first('nivel') }}</span>

        <div class="toggle-checkbox" :edit="showadd">
          <input type="checkbox" id="certificacion" v-model="newidioma.certificacion">
          <label for="certificacion">Con certificación</label>
        </div>

        <button class="btn" v-if="!!!newidioma.id" @click="sendnewidioma" :loading="loading">Añadir</button>
        <button class="btn" v-if="!!newidioma.id" @click="sendeditidioma" :loading="loading">Guardar</button>
      </div>
    </div>

  </div>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  import { Validator } from "vee-validate";

  Vue.use(VeeValidate);

  export default {
    name: 'idiomas-cv',
    props: ['info'],
    data() {
      return {
        showadd: false,
        showedit: false,
        loading: false,
        newidioma: {
          idioma: '',
          nivel: '',
          certificacion: false,
          otro: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        dominios: 'getDominios'
      })
    },
    methods: {
      ...mapActions(['addIdioma', 'eraseIdioma', 'editIdioma', 'canEditCv']),
      openadd() {
        this.canEditCv().then(r => {
          if (r) {
            this.showadd = r;
            this.reset();
          }
        });
      },
      openedit() {
        this.canEditCv().then(r => {
          if(!!!this.info){
            (r) ? this.showadd = !this.showadd : '';
          }else{
            (r) ? this.showedit = !this.showedit : '';
        }
        });
      },
      sendnewidioma() {
        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            this.loading = true;
            this.addIdioma(this.newidioma).then(r => {
              this.showadd = false;
              this.loading = false;
            }).catch(e => {
              this.showadd = false;
              this.loading = false;
              
            });
          }
        });
      },
      setEditIdioma(idioma) {
        this.showadd = true;
        this.newidioma = idioma;
      },
      sendeditidioma() {
        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            this.loading = true;
            this.editIdioma(this.newidioma).then(r => {
              this.showadd = false;
              this.loading = false;
            })
          }
        });
      },
      reset(){
        for(let i in this.newidioma){
          this.newidioma[i] = '';
        }
        this.newidioma.certificacion = false;
      }
    },
  }
</script>

<style scoped lang="scss">
  select {
    margin-bottom: 20px;

    &[aria-invalid=true] {
      margin-bottom: 0;
    }
  }

  input {
    width: 100%;
    margin-bottom: 20px;

    &[aria-invalid=true] {
      margin-bottom: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv/idiomas.vue